import api from "..";
import API_ENDPOINTS from "../endpoints";

export const getChallengeDetails = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.CHALLENGE_DETAILS,
    params: {
      c_id: data.c_id,
    },
  });

  return response.data;
};

export const getChallengeSubscriberAthleteList = async (data) => {
  const response = await api({
    method: "GET",
    url: API_ENDPOINTS.CHALLENGE_SUBSCRIBER_ATHLETE_LIST,
    params: {
      challenge_id: data.challenge_id,
      page: data?.page || 1,
      limit: data?.limit || 100,
    },
  });

  return response.data;
};
